<template lang="pug">
	div(style="position:relative;display:block;width:100%;")
		div.bg-white.buzon(
			v-for="buzon in listado"
			:key="buzon.ID_buzon"
		)
			div.tituloBuzon.pt-1.pb-1(
				:style="estilo"
				:class="(activo === buzon) ? 'bg-warning' : ''"
				@dblclick="toggleExpandir($event, buzon.ID_buzon)"
				@click="selecciona(buzon)"
				@contextmenu="menuContextual($event, buzon)"
			)
				div(style="cursor: pointer; position:relative;display:inline-block;width:10px;", @click="toggleExpandir($event, buzon.ID_buzon)")
					span(v-if="buzon.hijos.length > 0")
						span(v-if="expandir.indexOf(buzon.ID_buzon) >= 0") -
						span(v-else) +
				div(style="display:inline-block")
					span.fa.fa-folder.mr-2(:style="estiloBuzon(buzon)")
				div(style="display:inline-block") {{ buzon.nombre }}
			arbol-favoritos(:listado="buzon.hijos", v-if="buzon.hijos.length > 0 && expandir.indexOf(buzon.ID_buzon) >= 0", :nivel="nivel + 1", :activo="activo", @select="selecciona", @update="update")
			editor-buzones(v-if="editar", :padre="editar.padre", :buzon="editar.buzon", @cerrar="editar = null", @guardado="update")
</template>
<script>
import ArbolFavoritos from './arbol-favoritos.vue'
import EditorBuzones from './editor-favoritos.vue'
import { mapGetters } from 'vuex'
export default {
	name: 'arbol-favoritos',
	components: {
		'arbol-favoritos': ArbolFavoritos,
		'editor-buzones': EditorBuzones
	},
	props: ['listado', 'nivel'],
	data () {
		return {
			expandir: [],
			editar: null
		}
	},
	computed: {
		...mapGetters({
			'activo': 'organizar-emisoras/buzonActivoFavoritos'
		}),
		estilo () {
			return {
				paddingLeft: (5 + (this.nivel * 10)) + 'px',
				cursor: 'default'
			}
		}
	},
	methods: {
		selecciona (buzon) {
			this.$store.dispatch('organizar-emisoras/seleccionaBuzonFavorito', buzon)
		},
		toggleExpandir (e, idBuzon) {
			e.preventDefault()
			e.stopPropagation()
			const idx = this.expandir.indexOf(idBuzon)

			if (idx >= 0) {
				this.expandir.splice(idx, 1)
			} else {
				this.expandir.push(idBuzon)
			}
		},
		estiloBuzon (buzon) {
			return {}
		},
		menuContextual (e, buzon) {
			e.preventDefault()
			e.stopPropagation()
			this.selecciona(buzon)
			const menu = {
				titulo: 'Favoritos',
				evento: e,
				items: []
			}

			menu.items.push({
				texto: 'Nuevo buzón',
				icono: 'fa fa-folder',
				activo: true,
				callback: () => {
					this.editar = {
						padre: buzon,
						buzon: {
							ID_buzon: null,
							nombre: null,
							BuzonPadre: buzon.ID_buzon
						}
					}
				}
			})

			menu.items.push({
				texto: 'Eliminar',
				icono: 'fa fa-trash',
				activo: true,
				callback: () => {
					this.eliminar(buzon)
				}
			})
			this.$store.commit('contextual/mostrar', menu)
		},
		eliminar (buzon) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar buzón',
				mensaje: '¿Quieres eliminar este buzón?',
				callback: acepta => {
					if (acepta) {
						this.$store.dispatch('organizar-emisoras/delBuzonFavorito', buzon)
					}
				}
			})
		},
		update () {
			this.$emit('update')
		}
	}
}
</script>

<style scoped>
	.buzon {
		border-bottom: 1px solid #e0e0e0;
	}

	.buzon:first {
		border-top: 1px solid #e0e0e0;
	}

	.buzon:last-of-type {
		border-bottom: none;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/organizar-emisoras/vue/paginas/organizar/arbol-favoritos.vue